import "./Scheduling.module.css";
import Cabecalho from "@/reusable_sections/Header";
import FaleComEspecialista from "./sections/FaleComEspecialista";
import LocalizacaoEHorarios from "./sections/LocalizacaoEHorarios";
import Rodape from "@/reusable_sections/Footer";
export default function SchedulingPage() {
  return <div>
      <Cabecalho />
      <FaleComEspecialista />
      <LocalizacaoEHorarios />
      <Rodape />
    </div>;
}